export const TIME_CONSTANTS = {
  DEFAULT_START: '05:00',
  INTERVAL: 3,
};



// WEBPACK FOOTER //
// ./src/constants/time.js